import { extendTheme } from '@chakra-ui/react';
import { FONT_FAMILY } from '@/constants/default-props';
import { ASSET_PATTERN_COLOR, BG_COLOR, TEXT_COLOR } from '@/constants/colors';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: 'Ephesis',
    subHeading: 'Ephesis',
    body: 'Baskervville',
    name: 'Baskervville',
    // hardcoded font family for qrcode purpose
    jost: `'Jost', sans-serif;`,
  },
  fontSizes: {
    heading: '76px',
    subHeading: '33px',
    body: '16px',
    name: '48px',
  },
  fontWeights: {
    heading: 500,
    subHeading: 500,
    body: 400,
    name: 400,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-body': '',
        '--fontItalic-name': '',
      },
    },
  },
  colors: {
    bgPrimary: 'rgba(241,242,243,1)',
    bgSecondary: 'rgba(104,115,135,1)',
    bgTertiary: 'rgba(167,142,85,1)',
    bgAlternative: 'rgba(104,115,135,1)',
    mainColorText: 'rgba(167,142,85,1)',
    secondaryColorText: 'rgba(27,48,80,1)',
    tertiaryColorText: '#a78e55',
    alternativeColorText: 'rgba(252,252,252,1)',
    assetPatternColor: 'rgba(27,48,80,1)',

    transparent: 'transparent',
  },
};

export default extendTheme(theme);
